import { render } from "./EmailSubscribers.vue?vue&type=template&id=55cdc484&scoped=true&lang=pug"
import script from "./EmailSubscribers.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailSubscribers.vue?vue&type=script&setup=true&lang=js"

import "./EmailSubscribers.vue?vue&type=style&index=0&id=55cdc484&scoped=true&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55cdc484"]])

export default __exports__